import {isString} from "lodash";
import moment, {isMoment, Moment} from "moment";
import config from "../app/config";

export class UtilsMomentJS {

    static serializeDates(insertObj) {
        let obj = {...insertObj};
        let momentJSKeys = [];
        Object.keys(obj).forEach((key) => {
            if (isMoment(obj[key])) {
                momentJSKeys.push(key);
                obj[key] = obj[key].valueOf();
            }
        });
        obj["__momentJSFields"] = momentJSKeys;
        return obj;
    }

    static deserializeDates(insertObj) {
        if (insertObj) {
            if (insertObj.__momentJSFields) {
                let obj = {...insertObj};
                obj.__momentJSFields.forEach((key) => {
                    if (obj[key]) {
                        obj[key] = Moment.moment(obj[key]);
                    }
                });
                delete obj.__momentJSFields;
                return obj;
            }
            return insertObj;
        }
        return null;

    }

    static getUTCDateFromECDSFormat(ECDSDate, ECDSTime, leaveSecond = false) {
        if (ECDSDate && ECDSTime) {
            if (isMoment(ECDSDate) && isMoment(ECDSTime)) {
                let date = moment(ECDSDate, config.ecdsDateFormat).format(config.ecdsDateFormat);
                let time = moment(ECDSTime, config.ecdsTimeFormat).format(config.ecdsTimeFormat);

                return leaveSecond ? moment(`${date} ${time}`).utc() : moment(`${date} ${time}`).set({second: 0}).utc();
            } else if (isString(ECDSTime) && isString(ECDSDate)) {
                return leaveSecond ? moment(`${ECDSDate} ${ECDSTime}`).utc() : moment(`${ECDSDate} ${ECDSTime}`).set({second: 0}).utc();
            }
        }
        return null;
    }

    static getLocalDateFromUTCECDSFormat(ECDSDate, ECDSTime) {
        if (ECDSDate && ECDSTime) {
            return moment.utc(`${ECDSDate} ${ECDSTime}`).local();
        }
        return null;
    }
}